<template>
  <div class="essential_information">
    <!-- 标题 -->
    <div class="tit">
      <span>基础信息</span>
    </div>
    <!-- content -->
    <div class="content body_content">
      <!-- 表单查询等相关操作 -->
      <el-form :model="params" ref="ruleForm" status-icon label-width="120px" label-position="left">
        <el-form-item label="头像:" prop="head">
          <uploadImg :params="params" :apiParams="apiParams"></uploadImg>
          <input type="hidden" v-model="params.head" />
        </el-form-item>
        <el-form-item
          label="用户名:"
          prop="user_name"
          :rules="[{required: true, message: '请输入用户名', trigger: 'blur'},{ min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }]"
        >
          <el-input class="input-width" placeholder="请输入用户名" v-model="params.user_name"></el-input>
        </el-form-item>
        <!-- <el-form-item
          label="公司名称:"
          prop="company"
          :rules="[{required: true, message: '请输入公司名称', trigger: 'blur'},{ min: 5, max: 50, message: '长度在 5 到 50 个字符', trigger: 'blur' }]"
        >
          <el-input class="input-width" placeholder="请输入用户名" v-model="params.company"></el-input>
        </el-form-item> -->
        <el-form-item label="性别:">
          <el-radio-group v-model="params.sex">
            <el-radio label="SexMan">男</el-radio>
            <el-radio label="SexWoMan">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="电话:">
          <div class="input-text" v-cloak>
            {{mobileMask}}
            <router-link class="bind" to="/personal_center/account_settings/mobile_phone_binding">修改</router-link>
          </div>
        </el-form-item>
        <el-form-item label="邮箱:">
          <div class="input-text" v-cloak>
            {{params.email}}
            <router-link class="bind" to="/personal_center/account_settings/mail_binding">绑定</router-link>
          </div>
        </el-form-item>
        <el-form-item label="联系地址:">
          <el-select class="input-width" v-model="params.city" placeholder="请选择">
            <el-option v-for="item in citys" :label="item.name" :key="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="remark"
          :rules="[{max: 200, message: '长度在200 个字符内', trigger: 'blur' }]"
          label="简介:"
          class="textarea-width"
        >
          <el-input
            type="textarea"
            v-model="params.remark"
            :row="5"
            :autosize="{ minRows: 4, maxRows: 6}"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="notarize" type="primary" @click="submit">保 存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import uploadImg from "@/components/file_upload/uploadImg.vue";
export default {
  components: {
    uploadImg
  },
  data() {
    return {
      defaultActive: "1-1",
      citys: [],
      userOld: {},
      params: {
        id: "",
        user_name: "",
        sex: "SexMan",
        mobile: "",
        email: "",
        city: "",
        remark: "",
        headPath: "",
        company: ""
      },
      upload_img: {
        catalog: "CatalogUserHead",
        loginKey: sessionStorage.getItem("loginKey"),
        is_public_read: true
      },
      apiParams: {
        params: {
          catalog: "CatalogUserHead",
          is_public_read: true
        },
        imgPath: "headPath", //图片展示字段
        fileId: "head" //文件id字段
      }
    };
  },
  computed: {
    mobileMask: function() {
      //加*
      if (typeof this.params.mobile === "string") {
        let strArr = this.params.mobile.split("");
        strArr.splice(3, 4);
        strArr.splice(3, 0, "****");
        return strArr.join("");
      } else {
        return "";
      }
    },
    info() {
      return this.$store.state.info;
    }
  },
  created() {
    if(this.$store.state.info){
      this.getParam();
    }else{
       this.needInfo('getParam');
    }
    this.getCity();
  },
  methods: {
    /* 监测个人信息 */
    needInfo(fn) {
      let watchAch = this.$watch("info", (val, oldVal) => {
        if (val) {
          this[fn]();
          watchAch(); //取消监听
        }
      });
    },
    getParam(){
      let info = this.$store.state.info;
      const {id,user_name,sex,mobile,email,city,remark,headPath,company} = info;
      this.params = Object.assign({},{id,user_name,sex,mobile,email,city,remark,headPath,company});
    },
    /*获取城市字典*/
    getCity: function() {
      let params = {
        pageNo: 0,
        pageSize: 9999,
        typeCode: "GuangdongCity"
      };
      this.api.getDictionaries(params).then(res => {
        if (res.error.err_code === 0) {
          this.citys = res.obj.list;
        }
      });
    },
    /*提交用户信息*/
    submit: function() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          /* 更新用户信息 */
          this.updateUser();
        } else {
          return false;
        }
      });
    },
    updateUser: function() {
      this.api.updateUser(this.params, true).then(res => {
        if (res.error.err_code === 0) {
          this.$confirm("保存成功", "成功", {
            confirmButtonText: "确定",
            showCancelButton: false,
            type: "success"
          }).then(() => {
            this.common.getUserInfo();
          });
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import "../../index.scss";
.essential_information {
  .content {
    padding-top: 20px;
  }
}
</style>
